import { Component, OnInit } from '@angular/core';
import blogpost from '../../../../data/blog/blog.json';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Router } from "@angular/router";
import { TransferService } from 'src/app/services/datashare/transfer.service';
@Component({
  selector: 'app-blogpost',
  templateUrl: './blogpost.component.html',
  styleUrls: ['./blogpost.component.css']
})
export class BlogpostComponent implements OnInit {

  constructor(private authService: AuthService, private router: Router, private transferService: TransferService ) { }
  public blogpost = blogpost;
  public modelNoticia: any;
  public intIdNoticia: any;
  arrRows = [{}];
  public modelNoticias: any;


  ngOnInit(): void {
    this.getNoticiasLista();
  }

  getNoticiasLista(){
    this.authService.getNoticiasLista().subscribe((resNoticias) => {
      if(resNoticias.intResponse == 200){
        this.arrRows.shift();
        this.modelNoticias = resNoticias.Result;
      }
    });
  }


  details(id) {
    this.transferService.clearData();
    this.transferService.setData({"idNoticia": id});

    this.router.navigate(["/blog-details/" + id]);
  }
}
